import script from "./PublicPersonVerification.vue?vue&type=script&setup=true&lang=ts"
export * from "./PublicPersonVerification.vue?vue&type=script&setup=true&lang=ts"

import "./PublicPersonVerification.vue?vue&type=style&index=0&id=fc4a6d0c&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc4a6d0c"]])

export default __exports__